module.exports = __webpack_public_path__ + "media/images/memo_splitter-28584323188dc221410f9d9c6d542f6c.svg";